import { KYMW7201Model } from '../kymw7201.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { Router } from '@angular/router';

/**
 * 運営商品情報取得
 *
 * @export 
 * @class GetOperationGoodsService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetOperationGoodsService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: KYMW7201Model;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub,
    private router: Router,
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetOperationGoodsService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OperationGoodsId: this.model.operationGoodsId
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetOperationGoodsService
   */
  execute(model: KYMW7201Model, operationGoodsId: string, successFunc: Function = null): void {
    this.model = model;
    this.model.operationGoodsId = operationGoodsId;
    this.successFunc = successFunc;
    this.send('getOperationGoods', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetOperationGoodsService
   */
  success(data: any): void {
    this.model.commitData(data);
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }

  /**
   * 業務エラー時のメソッド
   * @param errList サーバ受信データ
   * 機能独自の処理を行う場合、このメソッドをオーバーライドして処理を実装する。
   */
  public plessErrorHandler(errList: Object): void {
    super.plessErrorHandler(errList);
    this.router.navigate(['/kymw/7200'], {
    });
  }

  /**
   * 特殊なエラーが返ってきた場合に呼び出されるメソッド。<br/>
   * 機能独自のステータスコードを持つ場合、このメソッドをオーバーライドして処理を実装する。
   */
  public exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
    this.router.navigate(['/kymw/7200'], {
    });
  }
}
